<template>
  <section class="mx-auto py-14 bg-[#f9f9f9]">
    <template v-if="isLoading">
      <div class="flex flex-col gap-6 px-5 container mx-auto">
        <UtilsSkeletonLoading class="w-full h-40 md:h-96" />
      </div>
    </template>
    <div v-else class="container mx-auto">
      <NuxtImg
        format="webp"
        srcset=""
        loading="lazy"
        :src="approachData.attributes?.image_mobile?.data?.[0]?.attributes?.url"
        quality="100"
        alt="Approach"
        title="Approach"
        class="md:hidden mx-auto w-full sm:w-4/5"
      />
      <NuxtImg
        format="webp"
        srcset=""
        loading="lazy"
        :src="approachData.attributes?.image?.data?.[0]?.attributes?.url"
        quality="100"
        alt="Approach"
        title="Approach"
        class="hidden md:block mx-auto w-4/5 xl:w-3/5"
      />
    </div>
    <div class="mx-auto text-center mt-8 md:mt-10">
      <NuxtLink
        to="/about/approach"
        title="Approach"
        class="btn btn-md md:btn-lg btn-primary-reverse w-max mx-auto"
      >
        Explore Our Approach
      </NuxtLink>
    </div>
  </section>
</template>

<script setup>
const isLoading = ref(true)

const approachData = ref([])

const getApproachData = async () => {
  const { data, error, pending } = await useSuitmediaApiData(
    `/api/image-approach-at-about-us`,
    {
      query: {
        'fields[0]': 'id',
        populate: 'image, image_mobile'
      }
    }
  )

  isLoading.value = pending.value

  if (error.value) {
    throw createError({
      statusCode: 404,
      message: `Journey/Timeline does not exist`
    })
  }

  return data.value
}

const approach = await getApproachData()
approachData.value = approach.data
</script>

<style lang="scss" scoped></style>
